import { fmtDate } from "@/lib/api";
import { useFetch } from "@/lib/useFetch";
import { Section } from "@/admin/hr/common";

export default function AuditLog() {
  const { data } = useFetch("/admin/hr/audit?limit=200");
  return (
    <Section title="Denetim kayıtları (son 200 işlem)" testid="audit-log">
      {!data ? <p className="text-sm text-zinc-500">Yükleniyor...</p> : data.length === 0 ? <p className="text-sm text-zinc-500">Kayıt yok.</p> : (
        <div className="max-h-[480px] overflow-auto">
          <table className="w-full text-sm">
            <thead className="sticky top-0 bg-white text-left text-xs uppercase tracking-wider text-zinc-500"><tr><th className="py-2 pr-3">Tarih</th><th className="py-2 pr-3">Kullanıcı</th><th className="py-2 pr-3">İşlem</th><th className="py-2 pr-3">Kayıt</th><th className="py-2">Ayrıntı</th></tr></thead>
            <tbody className="divide-y divide-zinc-100">
              {data.map((l) => (
                <tr key={l.id}>
                  <td className="whitespace-nowrap py-2 pr-3 text-zinc-500">{fmtDate(l.at)}</td>
                  <td className="py-2 pr-3">{l.user}</td>
                  <td className="py-2 pr-3 font-semibold">{l.action}</td>
                  <td className="py-2 pr-3">{l.target}</td>
                  <td className="py-2 text-xs text-zinc-500">{l.detail}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Section>
  );
}
